<template>
    <div class="middlepage">
        <img class="background-image" :src="preText + bgImg" alt="">
        <div class="more-btn" @click="handleMore" code-stm="event, PAGEURL, 查看更多">查看更多</div>
        <!-- 商品位 -->
        <div
          v-for="(item, index) in itemList"
          :key="index"
          :class="[
            'item-wrapper',
            `item-${index > 1 ? '2' : '1'}-${index > 1 ? index - 2 + 1 : index + 1}`,
            index > 1 ? 'row2-common' : '',
            { 'item-wrapper-first': index === 0 }
          ]"
          @click="clickItem(item)"
        >
            <img class="item-img" :src="item.coverImage" alt="">
            <div class="item-title"><span class="item-title-icon"></span><span>{{ item.productName }}</span></div>
            <!-- <div class="item-cover">
                <div class="qrcode-wrapper qrcode-1-1">
                    <img class="qrcode-img-1-1" v-img-lazy="preText + itemList[0].img_qrcode" alt="">
                </div>
            </div> -->
        </div>
    </div>
  </template>

  <script>
  import { isPortraitFun } from "@/utils/utils.js";
  import { queUrl } from "@/config/base";

  export default {
    name: 'part-right',
    props: {
      // 一级分类对象，用于请求推荐商品
      category: {
        type: Object,
        default: () => ({}),
      },
      bgImg: {
        type: String,
        required: true,
        default: ''
      },
      bigColor: {
        type: String,
        default: '#fff'
      },
    },
    data() {
      return {
        isPortrait: isPortraitFun(),
        preText:'https://www.kia.cn',
        // 默认占位，保证模板中 itemList[0..5] 一直存在，避免空指针
        itemList: [],
      };
    },
    created: function () {
      const href = window.location.href || "";
      if (href.includes("uat.kia.cn")) {
        this.preText = "https://uat.kia.cn";
      } else if (href.includes("www.kia.cn")) {
        this.preText = "https://www.kia.cn";
      } else {
        // 本地/测试环境
        this.preText = "https://uat.kia.cn";
      }
    },
    watch: {
      category: {
        handler(newVal) {
          if (newVal && newVal.catId) {
            this.fetchRecommendList(newVal.catId);
          }
        },
        immediate: true,
      },
    },
    methods: {
      async fetchRecommendList(catId) {
        try {
          const res = await this.$axios({
            method: "get",
            url: `${queUrl}api/shop/product/recommendList`,
            params: {
              categoryId: catId,
            },
          });
          if (res.data.code === 200) {
            this.itemList = res.data.rows || [];
          } else {
            this.itemList = [];
          }
        } catch (e) {
          console.warn("[PcPageRight] recommendList error:", e);
        }
      },
      clickItem: function (item) {
        this.$router.push({
          path: '/mall/detail',
          query: {
            id: item.productId,
          },
        });
      },
      handleMore() {
        this.$router.push({
          path: '/mallList',
          query: {
            parentId: this.category.catId,
            parentName: this.category.catName,
            forceRefresh: 1,
          }
        });
      }
    },
  };
  </script>

  <style lang="scss" scoped>


  @media (min-width: 767px) {
    .middlepage {
        position: relative;
        width: 100%;
        // aspect-ratio: 1920 / 1064;
        height: calc(1064 / 1920 * 100vw);
        user-select: none;
        z-index: 0;
    }
    .more-btn {
      position: absolute;
      top: calc(477 / 1920 * 100vw);
      left: calc(215 / 1920 * 100vw);
      font-size: calc(16 / 1920 * 100vw);
      color: #fff;
      background-color: #000;
      width: calc(120 / 1920 * 100vw);
      height: calc(40 / 1920 * 100vw);
      line-height: calc(40 / 1920 * 100vw);
      text-align: center;
      border-radius: calc(4 / 1920 * 100vw);
      cursor: pointer;
      transition: all 0.3s ease;
    }
    .background-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .item-wrapper {
        position: absolute;
    }
    .item-title {
        width: calc(100% - (24 / 1920 * 100vw));
        position: absolute;
        bottom: calc(12 / 1920 * 100vw);
        left: calc(12 / 1920 * 100vw);
        z-index: 99;
        // font-size: calc(15 / 1920 * 100vw);
        color: #000;
        display: flex;
        align-items: center; /* 让 icon 和文字垂直居中对齐 */
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .item-wrapper-first .item-title {
        color: v-bind(bigColor);
    }
    .item-title-icon {
        flex: 0 0 auto;
        display: inline-block;
        width: 3px;
        height: 1em; /* 跟文字同高，视觉齐平 */
        background-color: #C09D5A;
        margin-right: calc(8 / 1920 * 100vw);
    }
    .item-img {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        border-radius: calc(10 / 1920 * 100vw);
        cursor: pointer;
    }
    .item-cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(86, 86, 86, 0.8);
        border-radius: calc(17.66 / 1920 * 100vw);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
    }
    .item-wrapper:hover .item-cover {
        opacity: 1;
        pointer-events: auto;
    }
    .row2-common{
        top: calc(677.57 / 1920 * 100vw);
        width: calc(251.56 / 1920 * 100vw);
        height: calc(251.56 / 1920 * 100vw);
    }
    .item-1-1 {
        top: calc(202 / 1920 * 100vw);
        left: calc(562 / 1920 * 100vw);
        width: calc(722.8 / 1920 * 100vw);
        height: calc(459.19 / 1920 * 100vw);
    }
    .item-1-2 {
        top: calc(344.9 / 1920 * 100vw);
        left: calc(1305 / 1920 * 100vw);
        width: calc(316.63 / 1920 * 100vw);
        height: calc(316.63/ 1920 * 100vw);
    }
    .item-2-1 {
        left: calc(562 / 1920 * 100vw);
    }
    .item-2-2 {
        left: calc(831 / 1920 * 100vw);
    }
    .item-2-3 {
        left: calc(1099 / 1920 * 100vw);
    }
    .item-2-4 {
        left: calc(1367 / 1920 * 100vw);
    }
    .qrcode-common {
        z-index: 11;
    }
    .qrcode-1-1 {
        width: calc(207 / 1920 * 100vw);
        height: calc(207 / 1920 * 100vw);
        border-radius: calc(10 / 1920 * 100vw);
    }
    .qrcode-img-1-1 {
        width: calc(179 / 1920 * 100vw);
        height: calc(179 / 1920 * 100vw);
        border-radius: calc(10 / 1920 * 100vw);
    }
    .qrcode-1-2 {
        width: calc(168 / 1920 * 100vw);
        height: calc(168 / 1920 * 100vw);
        border-radius: calc(8 / 1920 * 100vw);
    }
    .qrcode-img-1-2 {
        width: calc(145 / 1920 * 100vw);
        height: calc(145 / 1920 * 100vw);
        border-radius: calc(8 / 1920 * 100vw);
    }
    .qrcode-2 {
        width: calc(133 / 1920 * 100vw);
        height: calc(133 / 1920 * 100vw);
        border-radius: calc(6.43 / 1920 * 100vw);
    }
    .qrcode-img-2 {
        width: calc(115 / 1920 * 100vw);
        height: calc(115 / 1920 * 100vw);
        border-radius: calc(6.43 / 1920 * 100vw);
    }
    .qrcode-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(20, 20, 20, 0.2);
        border: 0.81px solid rgba(192, 157, 90, 1)
    }
}
  </style>
